import LayoutPage from "../../Components/LayoutPage"
import Buttons from "./Components/Buttons"
import AnnouncementsList from "./Components/AnnouncementsList"

export default function Announcements() {
  return (
    <LayoutPage activeIndex={11} navItems={["مدیریت اعلانات"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto">
      <Buttons/>
      <AnnouncementsList/>
    </LayoutPage>
  )
}